<template>
  <div v-if="addAccountPop.isShow" class="addaccpop" style="z-index:3;">
    <qc-dialog
      :title="title"
      :width="600"
      type="custom"
      :show="true"
      :default-cancel="false"
      @close="onClose"
    >
      <section slot="default" class="content-box-wrap">
        <header>
          <p>员工可在PC端内打开链接进行申请；新员工申请加入后，需要你在权限管理页中确认。</p>
        </header>
        <div class="content-box">
          <section class="leftbox">
            <h4 class="title">
              链接邀请
            </h4>
            <div class="info-box">
              <div class="share-box">
                <input class="link-input" :value="link" type="text" readonly>
                <el-button class="btn-copy" @click="copyLink" size="small" type="primary">
                  复制链接
                </el-button>
              </div>
            </div>
          </section>
        </div>
        <div class="content-box">
          <section class="leftbox">
            <h4 class="title">
              邀请码邀请
            </h4>
            <div class="info-box">
              <div class="share-box">
                <input class="link-input" :value="inviteCode" type="text" readonly>
                <el-button class="btn-copy" @click="copyInviteCode" size="small" type="primary">
                  复制邀请码
                </el-button>
              </div>
            </div>
          </section>
        </div>
      </section>
      <footer>邀请链接有效时间30分钟</footer>
    </qc-dialog>
  </div>
</template>

<script>
import { config } from '@/config/index';
import { Helper } from '@/lib/helper';
import { mapState } from 'vuex';
import Api from '@/apis/invite/index';

export default {
  name: 'AddAccountPop',
  data() {
    return {
      title: '邀请新员工',
      isShow: false,
      inviteCode: '', // 邀请码
    };
  },
  computed: {
    ...mapState({
      addAccountPop: state => state.common.addAccountPop,
      profile: state => state.userCenter.profile,
    }),
    link() {
      return `${config.invitePage}?code=${this.inviteCode}`;
    },
  },
  watch: {
    addAccountPop: {
      handler(newVal) {
        const { isShow } = newVal;
        if (!isShow) return;

        this.getInviteCode();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async getInviteCode() {
      try {
        const reqData = {
          user_id: String(this.profile.user_id),
          uid: String(this.profile.uid),
        };
        const res = await Api.inviteGetCode(reqData);
        const code = Number(res?.head?.code);
        if (code !== 0) {
          const errorMsg = `[${code}] 获取邀请链接失败：${res?.head?.msg}`;
          this.$message.error(errorMsg);
          return;
        };

        this.inviteCode = res?.code || '';
      } catch (err) {
        const errorMsg = `[${err?.code}] 获取邀请链接失败：${err?.message}`;
        this.$message.error(errorMsg);
      }
    },
    onClose() {
      this.$store.commit('common/HIDE_ADD_ACCOUNT_POP');
    },
    onCancel() {
      this.$store.commit('common/HIDE_ADD_ACCOUNT_POP');
    },
    onConfirm() {
      this.$store.commit('common/HIDE_ADD_ACCOUNT_POP');
    },
    copyLink() {
      Helper.copyToClipboard(this.link);
      this.$tip({
        message: '链接已复制',
        type: 'success',
      });
    },
    copyInviteCode() {
      Helper.copyToClipboard(this.inviteCode);
      this.$tip({
        message: '邀请码已复制',
        type: 'success',
      });
    },
    openQQ() {
      window.open(
        'tencent://message/?Menu=yes&uin=&Site=80fans&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a545b1714f9d45',
        '_blank'
      );
    },
    openQrcodePop() {
      this.$store.commit('common/HIDE_ADD_ACCOUNT_POP');
      this.$store.commit('common/SHOW_INVITE_QRCODE_POP');
    },
    downloadFile(fileName, content) {
      const aLink = document.createElement('a');
      const blob = this.base64ToBlob(content);

      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true);
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      aLink.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      }));
    },
    base64ToBlob(code) {
      const parts = code.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;

      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    },
    downloadQrcodeImg() {
      const data = document.querySelector('#qrcode img').getAttribute('src');
      this.downloadFile('qrcode.png', data);
    },
  },
};
</script>

<style lang="less" scoped>
.addaccpop {
  position: relative;
  .tc-15-rich-dialog {
    position: relative;
  }
  .cancel-btn {
    margin-right: 10px;
  }
  .tc-15-btn.disabled {
    background-color: #6da8f7;
    color: #ddd;
    border: none;
  }
  header {
    padding: 0 25px;
  }
  .content-box {
    display: flex;
    .tip {
      padding-bottom: 20px;
    }
    .leftbox {
      flex: 1.2;
      padding: 0 25px;
      border-right: 1px solid #d8d8d8;
    }
    .rightbox {
      flex: 1;
      display: flex;
      justify-content: center;
      text-align: center;
      .img-qrcode {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 120px;
        margin: 0 auto 20px;
        border: 1px solid #d8d8d8;
        padding: 4px;
      }
    }
    .info-box {
      overflow: hidden;
      display: flex;
      align-items: center;
    }
    .title {
      margin-top: 30px;
    }
    .share-box {
      display: flex;
      justify-content: center;
      flex: 1;
      margin-top: 10px;

      .link-input {
        outline: none;
        flex: auto;
        padding: 0 20px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #dbdbdb;
        text-align: center;
        margin-right: 10px;
      }
      .btn-copy {
        min-width: 92px;
      }

      .tc-15-btn.m {
        min-width: 102px;
      }

      .item {
        flex: 1;
        justify-content: center;
        text-align: center;
        cursor: pointer;
      }
      .icon {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        border: 1px solid #d8d8d8;
        margin-bottom: 6px;
      }
    }
  }
  .btn-wrap {
    display: flex;
    justify-content: center;
  }
  .btm-tip {
    margin-top: 10px;
    color: #999;
  }
  footer {
    text-align: center;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f6f6f6;
    color: #999;
  }
}
</style>

<style lang="less">
.addaccpop {
  .tc-15-rich-dialog,
  footer {
    border-radius: 4px;
  }
  footer {
    margin-top: 40px;
  }
  .tc-15-rich-dialog-hd .tc-15-btn-close {
    right: 10px;
  }
  .tc-15-rich-dialog {
    padding: 25px 0 0;
  }
  .tc-15-rich-dialog-hd {
    padding: 0 25px;
  }
}
</style>
